import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiInstagram, FiFacebook } = FiIcons;

const ThreadsIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 192 192" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M141.537 88.988a66.667 66.667 0 0 0-2.518-1.143c-1.482-27.307-16.403-42.94-41.457-43.1h-.34c-14.986 0-27.449 6.396-35.12 18.036l13.779 9.452c5.73-8.695 14.724-10.548 21.348-10.548h.23c8.248.054 14.474 2.452 18.502 7.129 2.932 3.405 4.893 8.111 5.864 14.05-7.314-1.243-15.224-1.626-23.68-1.14-23.82 1.371-39.134 15.264-38.105 34.568.522 9.792 5.4 18.216 13.735 23.719 7.047 4.652 16.124 6.927 25.557 6.412 12.458-.683 22.231-5.436 29.049-14.127 5.178-6.6 8.453-15.153 9.899-25.93 5.937 3.583 10.337 8.298 12.767 13.966 4.132 9.635 4.373 25.468-8.546 38.376-11.319 11.308-24.925 16.2-45.488 16.351-22.809-.169-40.06-7.484-51.275-21.742C35.236 139.966 29.808 120.682 29.605 96c.203-24.682 5.63-43.966 16.133-57.317C56.954 24.425 74.204 17.11 97.013 16.94c22.975.17 40.526 7.52 52.171 21.847 5.71 7.026 10.015 15.86 12.853 26.162l16.147-4.308c-3.44-12.68-8.853-23.606-16.219-32.668C147.036 9.607 125.202.195 97.07 0h-.113C68.882.195 47.292 9.643 32.788 28.08 19.882 44.485 13.224 67.315 13.001 96c.223 28.685 6.88 51.515 19.788 67.92 14.504 18.437 36.094 27.885 64.172 28.08h.113c24.97-.173 42.555-6.708 57.048-21.189 18.963-18.945 18.392-42.692 12.142-57.27-4.484-10.454-13.033-18.945-24.727-24.553ZM98.44 129.507c-10.44.588-21.286-4.098-21.82-14.135-.397-7.442 5.296-15.746 22.461-16.735 1.966-.113 3.895-.169 5.79-.169 6.235 0 12.068.606 17.371 1.765-1.978 24.702-13.58 28.713-23.802 29.274Z"/>
  </svg>
);

const Footer = () => {
  const { t } = useLanguage();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const socialLinks = [
    {
      href: 'https://www.threads.com/@homy.hk',
      label: 'Threads',
      icon: <ThreadsIcon className="w-4 h-4" />,
    },
    {
      href: 'https://www.instagram.com/homy.hk',
      label: 'Instagram',
      icon: <SafeIcon icon={FiInstagram} className="w-4 h-4" />,
    },
    {
      href: 'https://www.facebook.com/profile.php?id=61578745554661',
      label: 'Facebook',
      icon: <SafeIcon icon={FiFacebook} className="w-4 h-4" />,
    },
  ];

  return (
    <footer className="mt-12 pb-6 text-center">
      <div className="inline-block px-6 py-2 bg-gradient-to-r from-purple-500/10 to-pink-500/10 dark:from-purple-500/20 dark:to-pink-500/20 rounded-full shadow-sm">
        <p
          className="text-sm font-medium"
          style={{
            background: 'linear-gradient(90deg,#5D5CDE,#FF8E8E)',
            WebkitBackgroundClip: 'text',
            backgroundClip: 'text',
            color: 'transparent',
          }}
        >
          Beat Buddy <span className="mx-1 text-red-500 animate-pulse">❤️</span>
          <a
            href="https://homy.hk"
            target="_blank"
            rel="noopener noreferrer"
            className="font-medium text-purple-600 dark:text-purple-400 hover:underline transition-all duration-300 hover:text-pink-600 dark:hover:text-pink-400"
            aria-label="訪問Homy Tech網站"
          >
            Homy Tech
          </a>
        </p>
      </div>

      {/* Social Media Links */}
      <div className="mt-4 flex items-center justify-center gap-3">
        {socialLinks.map((social) => (
          <a
            key={social.label}
            href={social.href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`訪問 ${social.label}`}
            className="w-8 h-8 flex items-center justify-center rounded-full bg-white dark:bg-gray-800 shadow-sm text-gray-500 dark:text-gray-400 hover:text-purple-600 dark:hover:text-purple-400 hover:shadow-md transition-all duration-200 hover:scale-110"
          >
            {social.icon}
          </a>
        ))}
      </div>

      <div className="mt-4 text-xs text-gray-500 dark:text-gray-400">
        <nav className="mt-2" aria-label="頁腳導航">
          <ul className="flex flex-wrap justify-center space-x-4">
            <li><Link to="/about" onClick={scrollToTop} className="hover:underline">{t('footerAbout')}</Link></li>
            <li><Link to="/features" onClick={scrollToTop} className="hover:underline">{t('footerFeatures')}</Link></li>
            <li><Link to="/help" onClick={scrollToTop} className="hover:underline">{t('footerHelp')}</Link></li>
            <li><Link to="/contact" onClick={scrollToTop} className="hover:underline">{t('footerContact')}</Link></li>
            <li><Link to="/privacy" onClick={scrollToTop} className="hover:underline">{t('footerPrivacy')}</Link></li>
            <li><Link to="/terms" onClick={scrollToTop} className="hover:underline">{t('footerTerms')}</Link></li>
          </ul>
        </nav>
      </div>
    </footer>
  );
};

export default Footer;